import documentReady from './document-ready';

documentReady(() => {
  window?.Intercom?.('update', {
      "hide_default_launcher": false
  });
})

let booted = false;
const boot = () => {
  if (booted) return;
  booted = true;

  const intercomOpener = document.querySelector("[title='open-intercome']");

  intercomOpener.addEventListener("click", (e) => {
    e.preventDefault();
    return Intercom("showNewMessage", "", {});
  });
};

window.addEventListener('load', boot);
